// Industry benchmarks: simplistic placeholder values. Replace with real datasets.

export type BenchmarkInput = {
  industry: string;
  employees: number;
};

export type BenchmarkResult = {
  avgKgCo2PerEmployee: number;
  avgKWhConsumption: number;
  avgWasteKg: number;
  improvementPotentialRange: { minPercent: number; maxPercent: number };
};

const DEFAULTS: Record<string, BenchmarkResult> = {
  manufacturing: {
    avgKgCo2PerEmployee: 12000,
    avgKWhConsumption: 18000,
    avgWasteKg: 900,
    improvementPotentialRange: { minPercent: 10, maxPercent: 35 }
  },
  it_services: {
    avgKgCo2PerEmployee: 3500,
    avgKWhConsumption: 4500,
    avgWasteKg: 120,
    improvementPotentialRange: { minPercent: 8, maxPercent: 25 }
  },
  logistics: {
    avgKgCo2PerEmployee: 9000,
    avgKWhConsumption: 12000,
    avgWasteKg: 600,
    improvementPotentialRange: { minPercent: 12, maxPercent: 30 }
  }
};

/**
 * Returns benchmark metrics for an industry and size.
 * Scales energy/waste linearly by employees; per-employee CO2 stays mean.
 */
export function getIndustryBenchmark(input: BenchmarkInput): BenchmarkResult & { scaledKWh: number; scaledWasteKg: number } {
  const key = normalizeKey(input.industry);
  const base = DEFAULTS[key] ?? DEFAULTS['it_services'];
  const employees = Math.max(1, input.employees);
  return {
    ...base,
    scaledKWh: base.avgKWhConsumption * employees,
    scaledWasteKg: base.avgWasteKg * employees
  };
}

function normalizeKey(industry: string): string {
  const k = industry.trim().toLowerCase().replace(/\s+/g, '_');
  return k in DEFAULTS ? k : 'it_services';
}



















